export default __webpack_public_path__ + "static/media/linkedln.8cc2cb3e.png";